app.config(
    ['$cookiesProvider',
        function ($cookiesProvider) {
            const expiryDate = new Date();
            expiryDate.setDate((expiryDate).getDate() + 365);
            $cookiesProvider.defaults.expires = expiryDate;
        }]);

